import { set } from 'lodash'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import type { Request } from '@/interfaces/request'

import { HotelConfirmationResponse } from '@/modules/confirmations/interfaces/hotelConfirmationResponse'
import { PaymentInfo } from '@/modules/hotels/interfaces/paymentInfo'

export const useConfirmationsStore = defineStore('confirmations', () => {
	const hotelConfirmations = ref<HotelConfirmationResponse[]>([])
	const generalConfirmations = ref<Request[]>([])
	const statusMessage = ref<string>('')
	const isManualReservation = ref<boolean>(false)
	const paymentConfirmationInfo = ref<{
		message: string
		paymentInfo: PaymentInfo
	} | null>(null)

	return {
		hotelConfirmations,
		generalConfirmations,
		statusMessage,
		isManualReservation,
		paymentConfirmationInfo,
		confirmations: computed(() => {
			return (
				hotelConfirmations.value.length ? hotelConfirmations.value
				: generalConfirmations.value.length ? generalConfirmations.value
				: []
			)
		}),

		setHotelConfirmations(
			value: HotelConfirmationResponse[],
			isManual?: boolean,
			message?: string,
			paymentInfo?: PaymentInfo
		) {
			hotelConfirmations.value = value
			isManualReservation.value = isManual || false
			paymentConfirmationInfo.value = {
				message: message!,
				paymentInfo: paymentInfo!,
			}
		},
		setGeneralConfirmations(value: Request[], isManual?: boolean) {
			generalConfirmations.value = value
			isManualReservation.value = isManual || false
		},
		setStatusMessage(value: string) {
			statusMessage.value = value
		},
	}
})
